import log from '@vcclive/log';
import { ServerEvent } from '../common';
import com from '../com';
import { IMessage, RootState } from './client-reducer';
import { SagaApi } from '../../interfaces/redux';

export class ClientEvents {
    private readonly api: SagaApi<RootState>;

    constructor(api: SagaApi<RootState>) {
        this.api = api;
    }

    public handler = ({ data: action }: SCEvent) => {
        switch (action.type) {
            case ServerEvent.agentAdded:
                this.api.dispatch({
                    type: 'addAgentToSession',
                    payload: action.payload,
                });
                break;
            case ServerEvent.agentLeft:
                this.api.dispatch({
                    type: 'removeAgentFromSession',
                    payload: action.payload,
                });
                break;
            case ServerEvent.messageAccepted: {
                const msg = action.payload;
                if (msg.from === com.getChannelName()) {
                    const message: IMessage = {
                        id: msg.id,
                        date: new Date(msg.date),
                        direction: 'out',
                        from: msg.from,
                        message: msg.message,
                        attachments: msg.attachments,
                    };
                    this.api.dispatch({
                        type: 'setMessageState',
                        payload: {
                            message,
                            state: 'sent',
                        },
                    });
                } else {
                    const message: IMessage = {
                        id: msg.id,
                        date: new Date(msg.date),
                        direction: 'in',
                        from: msg.from,
                        message: msg.message,
                    };
                    this.api.dispatch({
                        type: 'receiveMessage',
                        payload: message,
                    });
                }
                break;
            }
            case ServerEvent.pluginInitialized:
                this.api.dispatch({
                    type: 'initWebchat',
                    payload: { ...action.payload, pluginId: com.getChannelName() },
                });
                break;
            case ServerEvent.pluginInitializationFailed:
                log.error(action.type, action.payload);
                break;
            case ServerEvent.queueInfo:
                this.api.dispatch({
                    type: 'updateQueues',
                    payload: action.payload,
                });
                break;
            case ServerEvent.serverStarted:
                this.api.dispatch({ type: 'connectToServer' });
                break;
            case ServerEvent.sessionFinished:
                this.api.dispatch({
                    type: 'closeConversation',
                    payload: this.api.getState().root.settings,
                });
                break;
            case ServerEvent.sessionTransferred:
                this.api.dispatch({
                    type: 'updateQueue',
                    payload: action.payload,
                });
                break;
            default:
                log.warn(`Unknown action: ${action.type}`, action);
        }
    };
}
